
































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { TermsTab } from "@/shared/types";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";

@Component ({
  components: {
    Tab,
    TabGroup
  }
})
export default class Privacy extends Vue {
  readonly privacyPolicyFile = "bend_financial_privacy_policy_20181009.pdf";

  TermsTab = TermsTab;
  activeTab = TermsTab.Bank;

  mounted () {
    this.$on("tab-clicked", (event, tab) => {
      event.preventDefault();
      this.handleTabChange(tab.type);
    });
  }

  get privacyPolicyHref () {
    return `/${this.privacyPolicyFile}`;
  }

  handleTabChange (tabType) {
    this.activeTab = tabType;
  }
}
